import { memo, useEffect, useRef } from 'react'

const ReportProgress = memo(({ softcolors, color, className, style, value, minvalue, maxvalue }) => {
    const barRef = useRef(null)

    useEffect(() => {
        const elem = barRef.current
        if (!elem) return
        elem.style.width = '0%'
        elem.style.transition = 'width 2s'
        elem.style.width = `${value}%`
    }, [value])

    return (
        <div className={`progress bg-soft-${softcolors} ${className}`} style={style}>
            <div
                ref={barRef}
                className={`progress-bar bg-${color}`}
                role="progressbar"
                aria-valuenow={value}
                aria-valuemin={minvalue}
                aria-valuemax={maxvalue}
            />
        </div>
    )
})

ReportProgress.displayName = 'ReportProgress'
export default ReportProgress
